import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import StarIcon from '@material-ui/icons/Star'
import useStyles from './tab-panel.styles'

const TabPanel = (props) => {
  const {
    tabValue,
    tabIndex,
    accordionDetailHeading,
    accordionDetailBlurb,
    accordionDetailList,
  } = props

  const styles = useStyles()

  return (
    <div
      role="tabpanel"
      hidden={tabValue !== tabIndex}
      id={`fullheight-tablist-panel-${tabIndex}`}
      aria-labelledby={`fullheight-tablist-panel-${tabIndex}`}
    >
      {tabValue === tabIndex && (
        <Box sx={{ p: 3 }} className={styles.tabPanel}>
          <h3 className={styles.tabPanelHeading}>{accordionDetailHeading}</h3>
          <p className={styles.tabPanelsupportiveCopy}>{accordionDetailBlurb}</p>
          <ul className={styles.starCardList}>
            {accordionDetailList && accordionDetailList.map((listItem, index) => (
              <li className={styles.starCard} key={`workingolf-tabpanel-${tabIndex}-list-${index + 1}`}>
                <div className={styles.starPoint}>
                  <StarIcon className={styles.starIcon} color="secondary" />
                </div>
                <div className={styles.starCardCopy}>{listItem}</div>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  tabValue: PropTypes.number,
  tabIndex: PropTypes.number,
  accordionDetailHeading: PropTypes.string,
  accordionDetailBlurb: PropTypes.string,
  accordionDetailList: PropTypes.array,
}

export default TabPanel
